import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { MarvDateService } from '@marv/services';

@Pipe({
    name: 'marvTimeToDate'
})
export class MarvTimeToDatePipe implements PipeTransform {

    constructor(){}

    transform(value: unknown, ...args: any[]): Date {
        let date = new Date();       
        if(value && typeof value === 'string'){
            date = MarvDateService.FromTime(value);     
        }
        else{
            let mMin = 0;
            let minutesValues: Array<number> = args[0] || [];
            if(minutesValues.length > 0){
                let minutes = moment().minutes();  
                let m = minutesValues[0];
                let cpt = 1;
                while(m < minutes && cpt < minutesValues.length){
                    mMin = m;
                    m = minutesValues[cpt];
                    cpt++;
                }      
            }           
            date.setMinutes(mMin);
        }
        return date;
    }

}
